export enum UserRole {
  INCOMING = 'incoming',
  IN_PROCESS = 'in_process',
  OUTGOING = 'outgoing',
  CUSTOMER_SERVICE = 'customer_service',
  QUALITY_CONTROL = 'quality_control',
}
